module.exports = __webpack_public_path__ + "static/media/1014561.9bd0d3a7.jpg";